<template>
    <div class="chatDetail">

        <!-- 幼师端 -->
        <div class="chatDetailTop" v-if="jid">
            <span>{{jobInfo.job_opt_uid_name}}</span>
            <span>{{jobInfo.school_name}}</span>
        </div>

        <!-- 园长端 -->
        <div class="chatDetailTop" v-if="vid">
            <span>{{teaInfo.vita_name}}</span>
        </div>
        <div class="chatMsg" v-loading="loading">

            <!-- 幼师端 -->
            <div class="jobInfo" v-if="jid" @click="goJobDetail">
                <span>沟通职位</span>
                <span class="job_name">{{jobInfo.job_name}}</span>
                <span>{{jobInfo.salary_package}}{{jobInfo.salary_package === '面议'?'':'元/月'}}</span>
                <span>{{jobInfo.province_name?jobInfo.province_name:''}}{{jobInfo.city_name?jobInfo.city_name:''}}{{jobInfo.dist_name?jobInfo.dist_name:''}}</span>
            </div>

            <!-- 园长端 -->
            <div class="jobInfo" v-if="vid" @click="goTeaDetail">
                <span>意向职位</span>
                <span class="job_name">{{teaInfo.desired_position}}</span>
                <span>{{teaInfo.ideamoney}}{{teaInfo.ideamoney === '面议'?'':'元/月'}}</span>
                <span>{{teaInfo.province_name?teaInfo.province_name:''}}{{teaInfo.city_name?teaInfo.city_name:''}}{{teaInfo.dist_name?teaInfo.dist_name:''}}</span>
            </div>
            <div class="chatMsgBox">
                <div class="showMsg clearfix" v-for="(item, index) in showMsg" :key="index">
                    <div v-if="item.direction === 'right'" class="chatMsgContent chatMsgContentRight">
                        <div>{{item.content}}
                            <i class="el-icon-loading showMsgLoading" v-if="item.loading === true"></i>
                            <i class="el-icon-refresh-right showMsgLoading" v-if="item.loading === 'againType'" @click="sendMsg(item.content)"></i>
                        </div>
                        <el-avatar :size="36" :src="item.avatar" />
                    </div>
                    <div v-if="item.direction === 'left' && item.sms_type === 'common_sms'" class="chatMsgContent chatMsgContentLeft">
                        <el-avatar :size="36" :src="item.avatar" />
                        <div>{{item.content}}</div>
                    </div>
                    <div v-if="item.direction === 'left' && item.sms_type === 'attach_sms'" class="chatMsgContent chatMsgContentLeft attach_sms">
                        <el-avatar :size="36" :src="item.avatar" />
                        <div class="attach_smsBox">
                            <div class="attach_smsTitle">{{item.content}}</div>
                            <el-row :gutter="0">
                                <el-col :span="12"><div class="attach_smsBtn attach_smsBtnNo">否</div></el-col>
                                <el-col :span="12"><div class="attach_smsBtn attach_smsBtnYes" @click="sendFile">是</div></el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sendChat">
                <div class="sendChatTool clearfix" v-if="jid">
                    <el-tooltip class="item" effect="dark" content="投递" placement="top-start">
                        <div class="fl" @click="Delivery">
                            <svg-icon iconClass="toudi"></svg-icon>
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="不感兴趣" placement="top-start">
                        <div class="fl" @click="inappropriate">
                            <svg-icon iconClass="cha"></svg-icon>
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="发送简历" placement="top-start">
                        <div class="fl" @click="sendFile">
                            <svg-icon iconClass="chatFile"></svg-icon>
                        </div>
                    </el-tooltip>
                </div>
                <div class="sendChatTool clearfix" v-if="vid && setMeal.VitaMobile">
                    <el-tooltip class="item" effect="dark" content="收藏" placement="top-start">
                        <div class="fl" @click="beInterested">
                            <i style="color: #868b9a;" :class="teaInfo.favorite === 1?'el-icon-star-on':'el-icon-star-off'"></i>
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="不合适" placement="top-start">
                        <div class="fl" @click="inappropriate">
                            <svg-icon iconClass="cha"></svg-icon>
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="下载简历" placement="top-start">
                        <div class="fl" @click="getAttach">
                            <svg-icon iconClass="chatFile"></svg-icon>
                        </div>
                    </el-tooltip>
                </div>
                <div class="sendChatBox" v-if="jid || setMeal.VitaMobile">
                    <el-input
                        type="textarea"
                        :rows="3"
                        resize="none"
                        @keyup.enter.native="sendMsg(sendText)"
                        v-model="sendText">
                    </el-input>
                    <div class="sendBtn">
                        <span>按Enter键发送</span>
                        <el-button round size="mini" type="primary" @click="sendMsg(sendText)">发送</el-button>
                    </div>
                </div>
                <div v-else class="noChat">
                    <div><img :src="weChatCode" style="width: 100px;" alt=""></div>
                    <div>{{setMeal.CallUpNumber === -1?'你尚未开通该地区会员，请联系客服!':'您的免费次数已用完，请扫码开通权限'}}</div>
                    

                    <!-- <el-popover
                        placement="bottom"
                        width="100"
                        trigger="click">
                        <img :src="weChatCode" style="width: 100%;" alt="">
                        <el-button slot="reference" type="primary">{{setMeal.CallUpNumber === -1?'你尚未开通该地区会员，请联系客服!':'开通畅聊，立即回复'}}</el-button>
                    </el-popover> -->
                </div>
            </div>
        </div>

        <!-- 上传 -->
        <upload :uploadDialog="uploadDialog" @closeUpload="closeUpload" @uploadSuccess="uploadSuccess" />
    </div>
</template>

<script>
    import upload from '@/components/upload'
    import { getWeChatCode } from '@/js/common.js'

    export default {
        components: {
            upload
        },
        props: {
            jid: Number,
            vid: Number,
            avatar: String
        },
        data() {
            return {
                uploadDialog: false, // 上传
                jobInfo: {},
                showMsg: [],
                teaInfo: {},
                loading: false,
                sendText: '',
                socket: '',
                meAvatar: '',
                chat_uid: '',
                setMeal: {},
                weChatCode: '',
                timeCode: 10
            }
        },
        watch: {
            jid() {
                // 切换时用到
                this.showMsg = []
                this.getJob()
            },
            vid() {
                this.showMsg = []
                this.getTea()
                this.getSetMeal()
            }
        },
        mounted() {

            // 进入请求历史记录
            if(this.jid) {

                // 幼师端
                this.getJob()
                this.getMeResume()
            }
            if(this.vid) {

                // 园长端
                this.getTea()
                this.getSchool()
                this.getSetMeal()
            }

            this.init()
            getWeChatCode(this, 'bossjoin/pages/buyCallUpCount/buyCallUpCount', '1')
        },
        methods: {

            // 获取园长端套餐
            getSetMeal(e) {
                let obj = {}
                if(e) {
                    obj = {
                        vid: this.vid,
                        chat_id: this.teaInfo.uid,
                        is_get_mobile: 1,
                    }
                } else {
                    obj = {
                        vid: this.vid
                    }
                }
                this.api.get('/5d03ddc6b7222', obj).then(r => {
                    this.setMeal = r.data
                })
            },

            // 关闭上传
            closeUpload(uploadDialog) {
                this.uploadDialog = uploadDialog
            },

            // 上传成功
            uploadSuccess(e) {
                if(e) {
                    this.uploadDialog = false
                    this.getMeResume()
                }
            },

            // 园长请求简历
            getAttach() {
                this.api.post('/627ca48e77f11', { vuid: this.teaInfo.uid }).then(r => {
                    if(r.data.attach) {
                        window.open(r.data.attach)
                    } else {
                        this.sendMsg('file')
                    }
                })
            },

            // 幼师发送简历
            sendFile() {
                if(this.teaInfo.attach) {
                    this.api.post('/627ca4e132637', { sid: this.jobInfo.sid }).then(r => {
                        this.sendMsg('file')
                        this.$message({
                            message: '发送成功',
                            type: 'success'
                        });
                    })
                } else {
                    this.uploadDialog = true
                }
            },

            // 感兴趣
            beInterested() {
                this.api.get('/5cfe8357756cc', { vid: this.vid }).then(r => {
                    this.teaInfo.favorite = this.teaInfo.favorite === 1?0:1
                    this.$message({
                        message: this.teaInfo.favorite === 1?'收藏成功':'取消收藏',
                        type: 'success'
                    });
                })
            },

            // 获取简历
            getTea() {
                this.api.get('/5cf3c8627109c', { vid: this.vid }).then(r=>{
                    this.teaInfo = r.data
                    this.chat_uid = this.teaInfo.uid
                    this.getHistory(this.teaInfo.uid)
                })
            },

            getSchool() {
                this.api.get('/5cee6525269f6', {  }).then(r=>{
                    this.jobInfo = r.data
                    this.jobInfo.school_avatar = this.jobInfo.avatar
                    this.meAvatar = r.data.school_avatar
                })
            },

            // 投递
            Delivery() {
                this.api.get('/5cfe0bd997f6e', { jid: this.jid }).then(r=>{
                    this.$message({
                        message: '投递成功',
                        type: 'success'
                    });
                })
            },

            // 不合适、不感兴趣
            inappropriate() {
                let tipMsg = this.jid?'您是否确认不考虑应聘对方的工作职位？':'您是否确认对方不适合您招聘的职位？'
                this.$confirm(tipMsg, '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.sendMsg(this.jid?'对不起，我暂时不考虑贵单位的工作职位，谢谢您的支持！':'对不起，您暂时不适合我方招聘的岗位，谢谢您的支持！')
                })
            },

            // WebSocket连接
            init() {
                if(typeof(WebSocket) === "undefined"){
                    alert("您的浏览器不支持socket")
                }else{
                    // 实例化socket
                    this.socket = new WebSocket(this.api.socketUrl)
                    // 监听socket连接
                    this.socket.onopen = this.open
                    // 监听socket错误信息
                    this.socket.onerror = this.error
                    // 监听socket消息
                    this.socket.onmessage = this.getMessage
                }
            },

            // 连接错误
            error: function () {
                this.init()
            },

            // socket登录
            open: function () {
                let login_data = {
                    type: 'login',
                    access_token: JSON.parse(this.Cookies.get('AccessToken')).access_token
                }
                this.socket.send(JSON.stringify(login_data))
                console.log("socket连接成功")
            },

            // 接收服务器消息
            getMessage: function (msg) {
                let data = JSON.parse(msg.data)
                console.log(data)
                console.log(data.sender_uid, this.chat_uid)
                if(data.sender_nickname === '对方' && data.chat_content && data.sender_uid === this.chat_uid) {
                    this.showMsg.push({
                        content: data.chat_content,
                        sms_type: data.say_type,
                        uid: this.jid?this.jobInfo.job_opt_uid:this.teaInfo.uid,
                        direction: 'left',
                        avatar: this.jid?this.jobInfo.school_avatar:this.teaInfo.avatar,
                    })
                    this.scDown()
                }
            },

            // 获取职位详情
            getJob() {
                this.loading = true
                this.api.get('/5cf08ebdab59e', { jid: this.jid }).then(r=>{
                    this.jobInfo = r.data
                    this.chat_uid = this.jobInfo.job_opt_uid
                    this.getHistory(this.jobInfo.job_opt_uid)
                })
            },

            // 获取自己的简历
            getMeResume() {
                this.api.get('/5cf3c3436edc5', { }).then(r=>{
                    if(r.data.list.length > 0) {
                        this.api.get('/5cf3c3dd5d8d3', { vid: r.data.list[0].vid }).then(r=>{
                            this.teaInfo = r.data
                            this.meAvatar = r.data.avatar
                        })
                    }
                })
                
            },

            // 去职位详情
            goJobDetail() {
                let routeData = this.$router.resolve({
                    path:'/job/postDetail?jid=' + this.jobInfo.jid
                })
                window.open(routeData.href, '_blank');
            },

            // 去简历详情
            goTeaDetail() {
                let routeData = this.$router.resolve({
                    path: '/boss/resumeDetail',
                    query: {
                        vid: this.vid
                    },
                })
                window.open(routeData.href, '_blank');
            },

            // 请求历史消息
            getHistory(chat_uid) {
                let obj = {
                    chat_uid,
                    type: this.jid?'teacher_to_school':"school_to_teacher"
                }
                this.api.post('/60fa7b2930d18', obj).then(r=>{
                    this.loading = false
                    let showMsg = []
                    let userUid = JSON.parse(this.Cookies.get('members')).uid
                    r.data.list.forEach(o=>{
                        showMsg.push({
                            content: o.sms_content,
                            sms_type: o.sms_type === 1?'common_sms':'attach_sms',
                            uid: o.sender_uid,
                            direction: o.sender_uid === userUid?'right':'left',
                            avatar: userUid === o.sender_uid?this.meAvatar:this.avatar
                        })
                    })
                    this.showMsg = showMsg
                    this.scDown()
                })
            },

            // 发送对话
            sendMsg(val) {
                if(val) {
                    let chat_uid = this.jid?this.jobInfo.job_opt_uid:this.teaInfo.uid
                    let sendMsg = {}
                    let obj = {}
                    if(val === 'file') {
                        sendMsg = {
                            say_type: 'attach_sms',
                            type: 'say',
                            access_token: JSON.parse(this.Cookies.get('AccessToken')).access_token,
                            chat_uid,
                            chat_content: this.jid?'我已发送附件简历，请点击下载简历进行查看，谢谢！':'我想要一份您的附件简历，您是否同意',
                        }
                        obj = {
                            chat_uid: chat_uid,
                            sms_content: this.jid?'我已发送附件简历，请点击下载简历进行查看，谢谢！':'我想要一份您的附件简历，您是否同意',
                            sms_type: 2,
                            type: this.jid?'teacher_to_school':'school_to_teacher',
                        }
                    } else {
                        sendMsg = {
                            say_type: 'common_sms',
                            type: 'say',
                            access_token: JSON.parse(this.Cookies.get('AccessToken')).access_token,
                            chat_uid,
                            chat_content: val,
                        }
                        console.log(JSON.stringify(sendMsg))
                        obj = {
                            chat_uid,
                            sms_content: val,
                            sms_type: 1,
                            type: this.jid?'teacher_to_school':'school_to_teacher',
                        }
                    }

                    this.showMsg.push({
                        content: sendMsg.chat_content,
                        sms_type: sendMsg.say_type,
                        uid: this.jid?this.jobInfo.job_opt_uid:this.teaInfo.uid,
                        direction: 'right',
                        avatar: this.jid?this.teaInfo.avatar:this.jobInfo.school_avatar,
                        loading: true
                    })
                    this.scDown()
                    this.showMsg.forEach(o=>{
                        let setTimer = setInterval(() => {
                            this.timeCode = this.timeCode - 1
                            if (this.timeCode === 0) {
                                o.loading = 'againType'
                                this.timeCode = 10
                                clearInterval(setTimer)
                            }
                            if(!o.loading) {
                                clearInterval(setTimer)
                            }
                        }, 1000)
                    })

                    // 即时消息发送
                    this.socket.send(JSON.stringify(sendMsg))

                    // 历史消息发送
                    this.api.post('/60a870497ddc9', obj).then(r=>{
                        this.sendText = ''
                        if(this.showMsg.length === 0) {
                            // 扣次数
                            this.getSetMeal(true)
                        }
                        this.$nextTick(()=>{
                            setTimeout(() => {
                                this.showMsg.forEach(o=>{
                                    o.loading = false
                                })
                            }, 1000);
                        })
                    })

                }
            },

            // 滚动条下滑
            scDown() {
                this.$nextTick(()=>{
                    let box = this.$el.querySelector(".chatMsgBox")
                    box.scrollTop = box.scrollHeight
                })
            }
        },

    }
</script>

<style lang="scss" scoped>
    .chatDetailTop {
        line-height: 44px;
        height: 46px;
        padding-left: 22px;
        color: #9fa3b0;
        border-bottom: 2px solid #f2f2f5;
        background-color: #fbfbfc;
        white-space: nowrap;
        span {
            font-size: 13px;
            margin-right: 20px;
        }
    }
    .chatMsg {
        height: calc(100vh - 159px);
        background: white;
        .jobInfo {
            background: hsla(0,0%,98%,.9);
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            padding-left: 22px;
            cursor: pointer;
            span {
                margin-right: 15px;
            }
            .job_name {
                color: #ff6637;
            }
        }
    }
    .chatMsgBox::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 7px;
        /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }

    .chatMsgBox::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        background-color: rgba(144, 147, 153, 0.5);
    }

    .chatMsgBox::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #ededed;
        border-radius: 10px;
    }
    .chatMsgBox {
        padding: 30px 30px 20px;
        height: calc(100% - 242px);
        overflow-y: auto;
        .showMsg {
            margin-bottom: 10px;
            padding-top: 30px;
            .chatMsgContent {
                >div {
                    display: inline-block;
                    vertical-align: text-top;
                    max-width: 70%;
                    text-align: left;
                    word-break: break-all;
                }
                >span {
                    display: inline-block;
                    vertical-align: text-top;
                }
            }
            .chatMsgContentRight {
                text-align: right;
                >div {
                    position: relative;
                    background: blue;
                    border-radius: 6px;
                    color: white;
                    padding: 6px 20px;
                    margin-right: 10px;
                    .showMsgLoading {
                        position: absolute;
                        left: -20px;
                        color: #ff6637;
                        top: 9px;
                        cursor: pointer;
                    }
                }
            }
            .chatMsgContentLeft {
                text-align: left;
                >div {
                    background: #ff6637;
                    border-radius: 6px;
                    color: white;
                    padding: 6px 20px;
                    margin-left: 10px;
                }
            }
            .attach_sms {
                width: 46%;
                .attach_smsBox {
                    background: white;
                    padding: 0;
                    width: 100%;
                    border-radius: 8px;
                    overflow: hidden;
                    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                    .attach_smsTitle {
                        background: #ff6637;
                        padding: 6px 20px;
                    }
                    .attach_smsBtn {
                        margin: 5px 0;
                        text-align: center;
                        cursor: pointer;
                    }
                    .attach_smsBtnNo {
                        color: #999;
                        border-right: 1px solid #999;
                    }
                    .attach_smsBtnYes {
                        color: #FF5B12;
                    }
                }
            }
        }
    }
    .sendChat {
        height: 150px;
        border-top: 2px solid #f2f2f5;
        padding: 0 30px;
        .sendChatTool {
            padding-top: 15px;
            >div {
                margin-right: 20px;
                font-size: 24px;
                cursor: pointer;
            }
        }
        .sendChatBox {
            padding-top: 5px;
        }
        .sendBtn {
            text-align: right;
            >span {
                color: #d1d4db;
                font-size: 14px;
            }
        }
    }
    .noChat {
        padding-top: 10px;
        color: #999;
        text-align: center;
    }
</style>

<style lang="scss">
    .sendChatBox {
        textarea {
            padding: 0;
            border: none;
            font-size: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/chat/chatDetail.vue